// TODO need removed this file after Core Merge 24.7.4.0

export const getActualMode = ({ mode, isLoggedIn, funSupport }) => {
    let actualMode = mode !== undefined ? mode : 1;

    // if we try to open demo mode need to check if it's available
    if (!actualMode) {
        const gameModesMap = {
            both: 0,
            unavailable: 1,
            guest: Number(isLoggedIn),
            user: Number(isLoggedIn)
        };

        actualMode = gameModesMap[funSupport];
    }

    return actualMode;
};
/* TotalCasino changes */
